import React from "react";
import { Building2, MapPin, DollarSign, FileStack, Layers, Users } from "lucide-react";
import { money } from "./acqUi";

const FACTS = [
  ["location", "Location", MapPin], ["adjusted_premium", "Adjusted Premium", DollarSign], ["policies_in_force", "Policies in Force", FileStack],
  ["lines_of_business", "Main Lines of Business", Layers], ["staff_count", "Agency Staff", Users],
];

export default function OpportunityCard({ opp }) {
  if (!opp) return null;
  const val = {
    location: [opp.city, opp.state].filter(Boolean).join(", ") || null,
    adjusted_premium: opp.adjusted_premium != null ? money(opp.adjusted_premium) : null,
    policies_in_force: opp.policies_in_force != null ? opp.policies_in_force.toLocaleString() : null,
    lines_of_business: opp.lines_of_business || null,
    staff_count: opp.staff_count != null ? String(opp.staff_count) : null,
  };
  const facts = FACTS.filter(([k]) => val[k]);
  return (
    <section id="acq-opportunity" className="scroll-mt-24 rounded-2xl border-2 border-[#006090]/30 bg-white overflow-hidden" data-testid="acq-opportunity-card">
      <div className="bg-[#006090] text-white px-6 py-4 flex items-center gap-3">
        <Building2 className="w-6 h-6 shrink-0" />
        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-sky-100">Your Acquisition Opportunity</p>
          <p className="font-display text-2xl font-bold truncate" data-testid="acq-opp-name">{opp.agency_name}</p>
        </div>
      </div>
      <div className="p-6 space-y-5">
        {facts.length > 0 && (
          <dl className="grid grid-cols-2 lg:grid-cols-5 gap-3">
            {facts.map(([k, l, Icon]) => (
              <div key={k} className="rounded-lg bg-slate-50 p-3" data-testid={`acq-opp-${k}`}>
                <dt className="text-[11px] uppercase tracking-wide text-slate-500 flex items-center gap-1"><Icon className="w-3.5 h-3.5" />{l}</dt>
                <dd className="font-semibold text-slate-900 mt-1 text-sm">{val[k]}</dd>
              </div>
            ))}
          </dl>
        )}
        {opp.summary && <p className="text-sm text-slate-700 leading-relaxed whitespace-pre-line" data-testid="acq-opp-summary">{opp.summary}</p>}
        <p className="text-xs text-slate-500">Details provided by your district team for planning. Final figures come from official Farmers records; the purchase price and terms are negotiated between you and the selling agent.</p>
      </div>
    </section>
  );
}
